<template>
  <div>
    <web-header :searchStatus="$route.query.moduleId"></web-header>
    <mini-crumb height="60px" location="活动 > 活动详情"></mini-crumb>
    <div class="content-body" ref="viewBox">
      <!--活动内容主体-->
      <div class="content-body_head_wrap">
        <el-row style="padding-top:40px">
          <el-col :span="9">
            <div class="content-body_head_l">
              <img :src="img.path" v-for="(img,index) in data.cover_photo_text" :key="index" />
            </div>
          </el-col>
          <el-col :span="15">
            <div class="content-body_head_r">
              <div class="detail_title">
                <h1 id="dt_title" class="detail_title_h1">
                  <div style="display: inline-block;float:left;"></div>
                  {{data.name}}
                </h1>
              </div>

              <div class="detail_time_attr_join" avalonctrl="detail_info_base_controller">
                <div class="detail_time_attr_join_gray" avalonctrl="party_join_controller">
                  <div class="detail_Attr">
                    <div class="title_txt">
                      <span class="didian"></span>地点
                    </div>
                    <a
                      class="detail_attr_blue"
                      href="javascript:;"
                    >{{data.province_text}}{{data.city_text}}{{data.country_text}}{{data.address}}</a>
                  </div>

                  <div class="detail_Time">
                    <div>
                      <div class="detail_Time_t">
                        <div class="title_txt">
                          <span class="shijian"></span>时间
                        </div>
                        <p>{{data.activity_start}} ~ {{data.activity_end}}</p>
                      </div>
                    </div>
                  </div>

                  <div class="detail_Time">
                    <div>
                      <div class="detail_Time_t">
                        <div class="title_txt">
                          <span class="detail_Joinnum_t"></span>报名
                        </div>
                        <p>
                          已报名
                          <span>{{data.activity_apply_count || 0}}</span>
                          人
                          / {{data.people_num?'仅限'+data.people_num+"人报名":'不限制名额'}}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="detail_join_ticket" v-if="data.ticket">
                    <div class="detail_join_ticket_con">
                      <div class="tc_c_feiLi_box">
                        <p class="title_txt" style="margin-top: 5px;">
                          <span class="piaozhong"></span>类型
                        </p>
                        <ul class="ticket tc_c_feiLi tc_c_feiLi_lt7 clearfix">
                          <li
                            v-for="(item,index) in data.ticket_list"
                            :key="index"
                            @click="ticketClick(index)"
                          >
                            <a href="javascript:;" :class="index==ticketIndex?'select':''">
                              <table>
                                <tbody>
                                  <tr>
                                    <td>
                                      <!--ms-if-->
                                      <!--ms-if-->
                                      <span class="ticket_des">{{item.title}}</span>

                                      <span
                                        class="ticket_money"
                                      >{{item.number===null||item.number===''?'不限名额':'剩余：'+item.number}}</span>

                                      <!--ms-if-->
                                      <!--ms-if-->
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div class="detail_join_ticket" avalonctrl="detail_coupon_controller">
                    <div class="detail_join_ticket_con">
                      <div class="joinBox">
                        <ul class="join clearfix" avalonctrl="detail_join_party_controller">
                          <li class="show" avalonctrl="detail_join_party_list_controller">
                            <div class="detail_t_join">
                              <div style="display: inline">
                                <div style="display: inline;">
                                  <div style="display: inline;">
                                    <button
                                      class="myApply"
                                      :disabled="disabled"
                                      :style="disabled?'background-color:#ccc':''"
                                      rel="nofollow"
                                      @click="doLogin({success:sign})"
                                    >{{signText}}</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="detail_main_outside">
        <div class="detail_main_outside_top" :class="hover?'hover':''">
          <div class="wrap">
            <div class="wrap_box">
              <div class="detail current">
                <a href="javascript:void(0)">活动详情</a>
              </div>
              <div class="member" avalonctrl="detail_join_party_list_controller">
                <a @click="scrollBehavior" href="javascript:void(0)">
                  已报名
                  <span>{{data.activity_apply_count || 0}}</span>
                </a>
              </div>
              <ul class="join clearfix" style="display: block;" v-if="hover">
                <li class="show">
                  <div class="detail_t_join" name="detail_t_join">
                    <div style="display: inline">
                      <div>
                        <div style="display: inline;">
                          <button
                            class="myApply"
                            :disabled="disabled"
                            :style="disabled?'background-color:#ccc':''"
                            @click="doLogin({success:sign})"
                          >{{signText}}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <el-row>
          <el-col :span="18">
            <div class="detail_time_attr_det_con">
              <div class="detailContentTitle">
                <span class="tit">活动详情</span>
              </div>
              <div id="dt_content" class="dt_content" v-html="data.content"></div>

              <!--报名列表-->
              <div class="dt_join_menu_bg">
                <div class="detailContentTitle">
                  <span class="tit">
                    已报名
                    <span>（{{data.activity_apply_count || 0}}）</span>
                  </span>
                </div>
                <ul id="dt_list_main" class="dt_list_main">
                  <!--repeat872095507556:start-->
                  <li class="dt_review_main" v-for="(item,index) in applyInfo.list" :key="index">
                    <div class="dt_review_K">
                      <div class="dt_guess_item_icon">
                        <a class="yes-link" href="javascript:;">
                          <!--ms-if-->
                          <el-image class="default_img" :src="item.headimg_url">
                            <div slot="error" class="image-slot">
                              <img src="../../assets/images/big_logo.png" alt />
                            </div>
                          </el-image>
                          <!--ms-if-->
                        </a>
                        <!--ms-if-->
                      </div>
                      <div class="dt_guess_item_title dt_loadNew">
                        <a href="javascript:;" class="yes-link">{{item.user_name}}</a>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <recommend-news :tags="data.tag_list" v-if="data.tag_list"></recommend-news>
            <recommend-activity :tags="data.tag_list" v-if="data.tag_list"></recommend-activity>
            <!-- <recommend-project></recommend-project> -->
          </el-col>
        </el-row>
      </div>
    </div>
    <WtFooter></WtFooter>
  </div>
</template>
<script>
import "./info.css";
import webHeader from "../Public/header";
import miniCrumb from "../Public/miniCrumb";
import recommendNews from "_c/recommend/news";
import recommendActivity from "_c/recommend/activity";
import recommendProject from "_c/recommend/project";
export default {
  components: {
    webHeader,
    miniCrumb,
    recommendNews,
    recommendActivity,
    recommendProject
  },
  data() {
    return {
      ticketIndex: -1,
      signText: "我要报名",
      disabled: false,
      dialogTableVisible: true,
      hover: false,
      data: {},
      applyData: {},
      search: {
        type: null
      },
      liData: ["liBg1", "liBg2", "liBg3"],
      applyInfo: {
        list: [],
        total: 0
      }
    };
  },
  methods: {
    ticketClick(index) {
      let number = this.data.ticket_list[index].number;
      if (number === 0) {
        this.$message({
          showClose: true,
          message: "报名人数已满",
          type: "warning"
        });
      } else {
        this.ticketIndex = index;
        this.applyData.ticket_id = this.data.ticket_list[index].id;
      }
    },
    test() {
      this.$router.push({ name: "userInfo" });
    },
    //活动报名
    sign(e) {
      this.$db.get(this.$url.user.url).then(resp => {
        let data = resp.data;
        if (data) {
          if (this.data.type == 2) {
            //反哺活动，只能反哺大学生参与
            if (!data.is_college_student) {
              this.$notify({
                title: "提示信息",
                message: "该活动只允许反哺大学生参与",
                type: "warning"
              });
              return false;
            }
          }
          //如果是志愿者或者是反哺大学生  允许直接报名
          if (data.is_college_student || data.is_volunteer) {
            //判断是否需要提交表单
            if (this.data.fields) {
              let activity_id = this.applyData.activity_id;
              let ticket_id = this.applyData.ticket_id;
              this.$router.push({
                name: "custom",
                query: {
                  activity_id: activity_id,
                  ticket_id: ticket_id
                }
              });
            } else {
              this.disabled = true;
              this.signText = "正在提交报名";
              this.$db
                .post(this.$url.activity.apply.url, this.applyData)
                .then(resp => {
                  if (resp && resp.data) {
                    this.$message({
                      message: "报名成功",
                      type: "success",
                      duration: 1000,
                      onClose: function() {
                        window.location.reload();
                      }
                    });
                  } else {
                    this.disabled = false;
                    this.signText = "我要报名";
                  }
                });
            }
          } else {
            //登录过，但不是志愿者或者反哺大学生
            this.$confirm("您还不是志愿者，请先注册成为志愿者", "消息提示", {
              confirmButtonText: "立即前往注册",
              showCancelButton: false,
              type: "warning"
            })
              .then(() => {
                //跳转到志愿者注册页面
              })
              .catch(() => {});
          }
        }
      });
    },
    scrollBehavior() {
      document.getElementById("dt_list_main").scrollIntoView();
    },
    getDate(date, format = "M") {
      switch (format) {
        case "M": {
          return date.substring(5, 7);
          break;
        }
        case "D": {
          return date.substring(8, 10);
          break;
        }
      }
    },
    getClass(index) {
      let j = parseInt(index / 3);
      if (j % 2 == 0) {
        // 再通过取模来设置每隔3行显示不同的两种颜色
        return "liBg2";
      } else {
        //return "liBg3"
        return "liBg2";
      }
    },
    handleScroll() {
      if (this.getScrollBottomHeight() <= -650) {
        this.hover = true;
      } else {
        this.hover = false;
      }
    },
    //滚动条到底部的距离
    getScrollBottomHeight() {
      return (
        this.getPageHeight() - this.getScrollTop() - this.getWindowHeight()
      );
    },
    //页面高度
    getPageHeight() {
      return document.querySelector("html").scrollHeight;
    },
    //滚动条顶 高度
    getScrollTop() {
      var scrollTop = 0,
        bodyScrollTop = 0,
        documentScrollTop = 0;
      if (document.body) {
        bodyScrollTop = document.body.scrollTop;
      }
      if (document.documentElement) {
        documentScrollTop = document.documentElement.scrollTop;
      }
      scrollTop =
        bodyScrollTop - documentScrollTop > 0
          ? bodyScrollTop
          : documentScrollTop;
      return scrollTop;
    },
    getWindowHeight() {
      var windowHeight = 0;
      if (document.compatMode == "CSS1Compat") {
        windowHeight = document.documentElement.clientHeight;
      } else {
        windowHeight = document.body.clientHeight;
      }
      return windowHeight;
    },
    init() {
      let id = this.$route.query.id;
      this.activity_id = id;
      let that = this;
      this.$db
        .get(this.$url.activity.url + "/" + id)
        .then(resp => {
          const data = resp.data;
          this.data = data;
          this.applyData.activity_id = id;

          let is_sign = false; //是否可以报名，默认可以
          if (this.data.ticket) {
            //是定量活动
            for (let index = 0; index < this.data.ticket_list.length; index++) {
              let number = this.data.ticket_list[index].number;
              if (number === 0) {
                is_sign = true;
                continue;
              } else {
                is_sign = false;
                this.applyData.ticket_id = this.data.ticket_list[index].id;
                this.ticketIndex = index;
                break;
              }
            }
          }
          //活动时间未过、报名已截止
          if (data.activity_sign_up_status == 3 && data.activity_status != 3) {
            this.signText = "报名已截止";
            this.disabled = true;
          }
          //活动时间已过
          if (data.activity_status == 3) {
            this.signText = "活动已结束";
            this.disabled = true;
          }
        })
        .then(resp => {
          let params = {
            id
          };
          this.$db.post(this.$url.activity.checkApply, params).then(resp => {
            if (resp && resp.data.is_apply) {
              this.signText = "您已报名";
              this.disabled = true;
            }
          });
        })
        .then(resp => {
          //查询报名列表
          let search = {
            activity_id: id
            // page_size: 10
          };
          this.$db.post(this.$url.activity.apply.list, search).then(resp => {
            this.applyInfo.list = resp.data;
            this.applyInfo.total = resp.data.total;
          });
        });
    }
  },
  mounted() {
    this.init();
    window.addEventListener("scroll", this.handleScroll, true);
  },
  //页面销毁，页面销毁时移除监听事件，否则其他页面也会自动进入scroll的监听中
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  watch: {
    $route(to, from) {
      this.$router.go(0);
      //this.init()
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/view/Activity/info.vue